import axiosInstance from "../helpers/axiosInstance"

export const getWarehousePackingMaterials = async (warehouseId) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouse-packing-materials/warehouse/${warehouseId}`)
    return res.data
}
